<template>
  <div class="pic-word-one">
    <img class="corver-img" :src="info.bigPic?info.bigPic:info.picUrl"></img>
    <div class="corver-body">
      <div class="header">
        <div class="title">{{ info.title }}</div>        
      </div>
      <div class="desc">{{info.description}}</div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    info: { type: Object, default: {} }
  },
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>
